import { randomFloat, randomInteger } from '../utils'

const clearButton = document.querySelector('#clearButton');
clearButton.onclick = reloadTable;

const newButton = document.querySelector('#newButton');
newButton.onclick = newSudoku;

const helpButton = document.querySelector('#showHelp');
helpButton.onclick = showHelp;

const deduceNextButton = document.querySelector('#deduceNext');
deduceNextButton.onclick = deduceNext;

const resolveNextButton = document.querySelector('#resolveNext');
resolveNextButton.onclick = resolveNext;

const resolveAllButton = document.querySelector('#resolveAll');
resolveAllButton.onclick = resolveAll;

const selector = document.querySelector('#selector');

const solverProgress = document.querySelector("#SolverProgress")
solverProgress.style.display = "none"

const body = document.querySelector("body");
body.onload = documentLoaded;

let sudokuTable = undefined;
let sudokuSelector = undefined;

function documentLoaded() {
    const htmlTable = document.querySelector('#sudokuTable');
    sudokuTable = new SudokuTable(htmlTable)
    sudokuTable.generateRandom();
    sudokuSelector = new SudokuSelectorContainer();
    sudokuSolver = new SudokuSolver(sudokuTable);
    
    const legendHtmlTable = document.querySelector('#legendTable');
    var index = 1;
    for (let row of legendHtmlTable.rows) 
    {
        let colIndex = 0;
        for(let cell of row.cells) 
        {
            cell.style["background-color"] = getCellColor(index);
            cell.innerText = index;
            index++;
        }
    }
}

function showHelp() {
    sudokuTable.showHelp();
}

function deduceNext() {
    sudokuTable.deduceNext();
}

function resolveAll() {
    sudokuTable.resolveAll();
}

function resolveNext() {
    sudokuTable.resolveNext();
}

function reloadTable(){
    sudokuTable.clearAll();
}

function newSudoku(){
    sudokuTable.clearAll();
    sudokuTable.generateRandom();
}

function getCellColor(valuesLength)
{
    var color = "";
    switch(valuesLength)
        {
            case 0:
                color = "grey";
                break;
            case 1:
                color = "#ffeebc";
                break;
            case 2:
                color = "#dfe93a";
                break;
            case 3:
                color = "#f1c02e";
                break;
            case 4:
                color = "#ff9900";
                break;
            case 5:
                color = "#ff5e00";
                break;
            case 6:
                color = "#ff2f00";
                break;   
            case 7:
                color = "#a51515";
                break;
            case 8:
                color = "#a5153d";
                break;
            case 9:
                color = "#b814ed";
                break;                             

        }
    return color;
}

class SudokuSelectorContainer {
    constructor() {
        this.referencedCell = null;
        this.selectorCells = [];
        const selectorTable = document.querySelector('#selector-table');
        for (let row of selectorTable.rows) 
        {
            for(let cell of row.cells) 
            {
                this.selectorCells.push(new CellSelector(cell, this));
            }
        }
    }

    setReferencedCell(cell)
    {
        this.referencedCell = cell;
    }

    clicked(value) {
        this.referencedCell.valueSelected(value)
    }
}

class CellSelector {
    constructor(cell, selectorContainer){
        this.cell = cell;
        this.selectorContainer = selectorContainer;
        if(this.cell.innerText == "Cancel")
        {
            this.value = -1;
        }
        else if(this.cell.innerText == "Clear")
        {
            this.value = null;
        }
        else
        {
            this.value = parseInt(this.cell.innerText);
        }
        
        cell.onclick = this.onClick.bind(this);
    }

    onClick (args, event){
        this.selectorContainer.clicked(this.value);
    }
}

class SudokuCellRenderer {
    constructor(cell, cellController) {
        this.showingHelp = false
        this.cell = cell;
        this.helpNode = this.prepareHelpNode();
        this.cellController = cellController;
        cell.onclick = this.onClick.bind(this);
    }

    onClick (args, event){
        sudokuSelector.setReferencedCell(this);
        selector.style.display = "block"
        var rect = this.cell.getBoundingClientRect();
        selector.style.left = rect.left + rect.width;
        selector.style.top = rect.top - rect.height * 0.5;
    }

    valueSelected(value)
    {
        selector.style.display = "none"

        if(value > 0 || value == null)
        {
            this.cellController.setValue(value);
            this.updateValue();
        }
    }

    setValue(value, visible = true) {
        this.cellController.setValue(value);

        if (visible)
        {
            this.updateValue();
        }
    }

    updateValue() {
        this.cell.innerText = this.cellController.value;
        this.cell.style["background-color"] = this.cellController.value != null ? "grey" : "white";
    }

    prepareHelpNode() {
        var node = document.createElement("div");
        node.className = "help";
        this.cell.appendChild(node);
        return node;
    }

    showHelp() {
        if(this.showingHelp)
        {
            this.helpNode.innerText = ""
            this.updateValue();
            this.showingHelp = false;
            return;
        }
        if(this.cellController.value != null)
        {
            this.cell.innerText = this.cellController.value;
        }
        
        this.helpNode.innerText = Array.from(this.cellController.validValues).join().split(',');
        this.helpNode.innerText += "\n" + Array.from(this.cellController.onlyValidForMe).join().split(',');
        // this.helpNode.innerText += this.cellController.quadrant;
        // this.helpNode.innerText += this.cellController.row;
        // this.helpNode.innerText += this.cellController.col;      
        this.cell.style["background-color"] = getCellColor(this.cellController.validValues.size);
        this.cell.appendChild(this.helpNode);

        if(this.cellController.errors.length > 0)
        {
            this.cell.style["background-color"] = "red";
        }
        this.showingHelp = true;
    }
}

class SudokuCellController {
    constructor(row,col) {
        this.value = null;
        this.row = row;
        this.col = col;
        this.validValues = new Set()
        this.onlyValidForMe = new Set() 
        this.errors = []
    }

    resetValidValues() {
        this.errors = [];
        if(this.value != null)
        {
            this.validValues = new Set()
        }
        else{
            this.validValues = new Set([1,2,3,4,5,6,7,8,9])
        }
        
    }

    resetOnlyValidsForMe() {
        this.onlyValidForMe = new Set(Array.from(this.validValues))
    }

    incementValue() {
        
        if(this.value == null)
        {
            this.value = 1;
        }
        else
        {
            this.value++;
            if(this.value>9)
            {
                this.value = 1;
            }
        }
    }

    setValue(value) {
        this.value = value;
    }

    get quadrant() {
        return (Math.trunc(this.row/3) * 3) + Math.trunc(this.col/3);
    }

    removeOnlyValidForMe(otherCell) {
        if(!otherCell.equals(this))
        {
            var self = this;
            if( this.isColliding(otherCell)) {
                    otherCell.validValues.forEach(function(validValue) { 
                        var hasValue = self.onlyValidForMe.has(validValue);
                        if(hasValue)
                        {
                            self.onlyValidForMe.delete(validValue);
                        }
                    });

                }
        }
    }

    isColliding(otherCell){
        return otherCell.row == this.row ||
        otherCell.col == this.col ||
        otherCell.quadrant == this.quadrant;
    }

    isCollidingValue(otherCell) {
        return !otherCell.equals(this) && this.isColliding(otherCell) && this.value != null && this.value == otherCell.value;
    }

    removeInvalid(otherCell) {
        if(otherCell.equals(this)){
            this.removeFromValid(otherCell.value);
        }
        else if(this.isColliding(otherCell)) {
            
            this.removeFromValid(otherCell.value)
            if(this.value != null && this.value == otherCell.value)
            {
                this.errors.push(otherCell);
            }
        }
    }

    removeFromValid(value){
        if(value == null){
            return;
        }
        var hasValue = this.validValues.has(value);
        if(hasValue){
            this.validValues.delete(value);
            if(this.validValues.size == 0)
            {
                this.errors.push(this);
            }
        }
    }

    equals(otherCell){
        return this.row == otherCell.row && this.col == otherCell.col;
    }

}
class SudokuTable {
    constructor(htmlTable) {
        this.cells = []
        let rowIndex = 0;
        for (let row of htmlTable.rows) 
        {
            let colIndex = 0;
            for(let cell of row.cells) 
            {
                this.cells.push(new SudokuCellRenderer(cell, new SudokuCellController(rowIndex, colIndex)));
                colIndex++;
            }
            rowIndex++;
        }
    }

    generateRandom() {
        let pendingValues = [1,2,3,4,5,6,7,8,9]

        for(var i=0; i<9; i++)
        {
            let randomValueIndex = randomInteger(0,pendingValues.length - 1);
            let removedValue = pendingValues.splice(randomValueIndex, 1)[0]
            let randomCellIndex = randomInteger(0,8) + i * 9 ;
            this.cells[randomCellIndex].setValue(removedValue);
        }
    }

    getValues() {
        let returnValues = []
        this.cells.forEach(function(cell) {
            returnValues.push(cell.cellController.value)
        });
        return returnValues;
    }

    setValues(values, visible = true) {
        for(let index = 0; index < this.cells.length; index++)
        {
            this.cells[index].setValue(values[index], visible)
        }
    }

    validate() {
        let self = this;
        let errors = false;
        this.cells.forEach(function(cell) {
            self.cells.forEach(function(cell2) {
                let localErrors = cell.cellController.isCollidingValue(cell2.cellController)
                if (localErrors)
                {   
                    errors = true;
                    return;
                }
            });
        });
        return !errors;
    }

    recalculate() {
        let self = this;
        this.cells.forEach(function(cell) {
            cell.cellController.resetValidValues();
            self.cells.forEach(function(cell2) {
                cell.cellController.removeInvalid(cell2.cellController);
            });
        });

        this.cells.forEach(function(cell) {
            cell.cellController.resetOnlyValidsForMe();
            self.cells.forEach(function(cell2) {
                cell.cellController.removeOnlyValidForMe(cell2.cellController);
            });
        });
    }

    showHelp(recalculate = true) {
        this.recalculate();
        this.cells.forEach(function(cell) { 
            cell.showHelp();
        });

    }

    deduceNext() {
        this.recalculate();
        var found = false;
        this.cells.every(function(cell) { 
            if(cell.cellController.value == null)
            {
                if(cell.cellController.validValues.size == 1)
                {
                    found = true;
                    cell.cellController.setValue(cell.cellController.validValues.values().next().value);
                }
                else if(cell.cellController.onlyValidForMe.size == 1)
                {
                    cell.cellController.setValue(cell.cellController.onlyValidForMe.values().next().value);
                    found = true;
                }

                if(found) {
                    cell.updateValue();
                }

                return !found;
            }
            return true;
        });
        if(!found) {
            console.log("nothing to deduce");
        }
    }

    resolveNext() {
        sudokuSolver.startBackTrack(false);
    }

    resolveAll() {
        sudokuSolver.startBackTrack();
    }

    clearAll()
    {
        this.cells.forEach(function(cell) {
            cell.setValue(null);
        });
    }
}

let sudokuSolver = null;

const backtrackCallback = () => {
    sudokuSolver.backtrack()
}

class SudokuSolver
{
    constructor(sudokuTable)
    {
        this.sudokuTable = sudokuTable;
        this.initialState = null;
        this.stateStack = []
        this.visible = false;
        this.running = false;
        this.backtrackCount = 0;
    }

    isComplete(currentState) {
        let allCellsHaveValue = currentState.every(function(cellValue) {
            return cellValue != null
        });

        return this.sudokuTable.validate() && allCellsHaveValue;
    }

    startBackTrack(visible = true) {
        solverProgress.style.display = "block"

        if(this.running)
        {
            return;
        }
        this.initialState = sudokuTable.getValues()
        this.backtrackCount = 0;
        this.running == true;
        this.visible = visible;
        this.stateStack.push(Array.from(this.initialState))
        window.requestAnimationFrame(backtrackCallback)
    }

    getCurrentState() {
        return this.stateStack[this.stateStack.length - 1];
    }

    pushNewState() {
        this.stateStack.push(Array.from(this.getCurrentState()))
    }

    popLastState() {
        this.stateStack.pop()
    }

    getCurrentIndex(last = true) 
    {
        var currentState = null;
        if(last)
        {
           currentState = this.stateStack[this.stateStack.length - 1];
        }
        else
        {
            currentState = this.stateStack[this.stateStack.length - 2];
        }
        for(let index = 0; index < currentState.length; index++)
        {
           if (currentState[index] == undefined)
           {
                return index;
           }
        }
    }

    tryExploringNewValue(newValue)
    {
        let currentIndex = this.getCurrentIndex();
        this.pushNewState();
        this.getCurrentState()[currentIndex] = newValue;
        this.sudokuTable.setValues(this.getCurrentState(), this.visible)
    }

    nextStep()
    {
        this.backtrackCount++;

        let limit = 150;
        if(!this.visible)
        {
            limit = 300;
        }
        if(this.backtrackCount > limit)
        {
            this.backtrackCount = 0;
            window.requestAnimationFrame(backtrackCallback);
        }
        else
        {
            this.backtrack();
        }
    }

    backtrack()
    {
        var ignoreStep = false;
        if (this.isComplete(this.getCurrentState())) 
        {
            //console.log("solution found")
            //ignoreStep = true;
            solverProgress.style.display = "none"
            this.running = false

            if (!this.visible)
            {
                let finalState = this.getCurrentState();
                let initialState = this.stateStack[0];
                
                let pendingIndexes = []
                for(let i=0; i<finalState.length; i++)
                {
                    if(initialState[i] == null)
                    {
                        pendingIndexes.push(i);
                    }
                }
                let randomIndex = randomInteger(0,pendingIndexes.length);
                let selectedIndex = pendingIndexes[randomIndex]
                initialState[selectedIndex] = finalState[selectedIndex]
                this.sudokuTable.setValues(initialState);
            }
            else {
                //this.sudokuTable.setValues(, true)
            }
            
            this.stateStack.splice(0,this.stateStack.length);
            return true;
        }

        if (!this.sudokuTable.validate() || ignoreStep)
        {
            let currentIndex = this.getCurrentIndex(false);
            let currentValue = this.getCurrentState()[currentIndex]

            this.popLastState();

            currentValue++;
            if(currentValue <= 9)
            {
                this.tryExploringNewValue(currentValue)
            }
            else
            {
                var revertFinished = false
                while(!revertFinished)
                {
                    let currentIndex = this.getCurrentIndex(false);
                    let currentValue = this.getCurrentState()[currentIndex]
                    this.popLastState();
                    this.sudokuTable.setValues(this.getCurrentState(), this.visible)
                    currentValue++;
                    if(currentValue <= 9)
                    {
                        this.tryExploringNewValue(currentValue)
                        revertFinished = true;
                    }
                }
            }
            this.nextStep();
            //
            return false;
        }

        this.tryExploringNewValue(1)

        this.nextStep();
        return false;

    }
}